const IGNORED_TOKENS_AFTER_UNIT = new Set(["quiz", "content", "detail", "intro", "info", "seite", "placeholder", "draft", "bacnet", "modbus", "mbus", "knx", "dali", "smi", "asi", "rcd", "stepbystep"]);

function toPascalCase(token: string): string {
  if (!token) return '';
  if (/^[0-9]+$/.test(token)) return token;
  if (/^[a-z0-9]+$/.test(token)) {
    if (/[0-9]/.test(token)) return token.toUpperCase();
    return token.charAt(0).toUpperCase() + token.slice(1);
  }
  return token.toUpperCase();
}

export function slugToNavId(slug: string | undefined | null): string | null {
  if (!slug) return null;
  const tokens = slug.split('_').filter(Boolean);
  if (!tokens.length) return null;

  const moduleToken = tokens.shift();
  if (!moduleToken || !/^[a-zA-Z]\d+$/.test(moduleToken)) return null;

  let navId = moduleToken.toUpperCase();
  if (!tokens.length) return navId;

  const unitToken = tokens[0];
  if (/^[uU]\d+[a-z0-9]*$/.test(unitToken)) {
    navId += `_${unitToken.toUpperCase()}`;
    tokens.shift();

    while (tokens.length) {
      const token = tokens[0];

      if (/^[xX][0-9]+[a-z0-9]*$/.test(token)) {
        navId += `_${token.toUpperCase()}`;
        tokens.shift();
        continue;
      }

      const extraMatch = token.match(/^([a-z])(\d+[a-z0-9]*)$/i);
      if (extraMatch) {
        const letter = extraMatch[1].toUpperCase();
        if (['X', 'Y', 'Z', 'W', 'V'].includes(letter)) {
          navId += `_${letter}${extraMatch[2].toUpperCase()}`;
          tokens.shift();
          continue;
        }
      }

      if (IGNORED_TOKENS_AFTER_UNIT.has(token.toLowerCase())) {
        tokens.shift();
        continue;
      }

      break;
    }

    return navId;
  }

  const remainder = tokens.map(toPascalCase).join('');
  return remainder ? `${navId}_${remainder}` : navId;
}
